import { StoryblokAsset } from "../../../interfaces/StoryblokAsset.interface";
import { getSbGatsbyImageUrl } from "./getSbGatsbyImageUrl.util";

export const getSbGatsbyPlaceholderImageUrl = (asset: StoryblokAsset, ): string => {
    const width: number = 20;
    const height: number = 0;
    const fitIn: boolean = false;
    const fitInColour: string = 'transparent';
    const smartCrop: boolean = false;
    const quality: number = 20;
    return getSbGatsbyImageUrl(asset, quality, fitIn, fitInColour, smartCrop, width, height);
}